import { m8API } from 'services/production/m8';
import { AttachClientToGiroPaymentService } from 'types/services';
import { MissingClientRequisites } from 'utils/errors';

export const attachClientToGiroPayment: AttachClientToGiroPaymentService = async (
  paymentId,
  clientId
) => {
  const requisites = await m8API.admin.getUserLegalRequisites({
    idUser: clientId,
  });

  if (requisites) {
    await m8API.admin.attachStatement({
      idStatement: paymentId,
      idRequisit: requisites.id,
    });
  } else {
    throw new MissingClientRequisites();
  }
};
